module.exports = __webpack_public_path__ + "img/poke-ball-00.cea943ba.png";